import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import './navbar.css';
import logo from '../../assets/GOODNESS ONONOGBU LOGO.png';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="navbar-links">
        <div className="navbar-links-logo">
          <img src={logo} alt="GOODNESS ONONOGBU LOGO" />
        </div>

        {/* Links for larger screens */}
        <div className={`navbar-links-container ${toggleMenu ? 'show' : ''}`}>
          <p><b><a href="/">HOME</a></b></p>
          <p><b><a href="/about">ABOUT</a></b></p>
          <p><b><a href="/blog">BLOG</a></b></p>
          <p><b><a href="/projects">PROJECTS</a></b></p>
          <p><b><a href="/contact">CONTACT</a></b></p>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className="navbar-menu">
        <button
          className="menu-toggle"
          aria-label={toggleMenu ? 'Close menu' : 'Open menu'}
          aria-expanded={toggleMenu}
          onClick={() => setToggleMenu(t => !t)}
        >
          {toggleMenu ? (
            <RiCloseLine color="#fff" size={27} />
          ) : (
            <RiMenu3Line color="#fff" size={27} />
          )}
        </button>
        <div className={`navbar-menu-container-links ${toggleMenu ? 'show' : ''}`} role="menu" aria-hidden={!toggleMenu}>
          <p role="menuitem"><b><a href="/">HOME</a></b></p>
          <p role="menuitem"><b><a href="/about">ABOUT</a></b></p>
          <p role="menuitem"><b><a href="/blog">BLOG</a></b></p>
          <p role="menuitem"><b><a href="/projects">PROJECTS</a></b></p>
          <p role="menuitem"><b><a href="/contact">CONTACT</a></b></p>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
